<!-- Default display -->
<div *ngIf="message" id="page_message" class="{{message_class}} ribbon-message">{{message}}</div>
